import Entity from './entity'

export default class TestQuestion extends Entity<string>{

    //章节的节Id
    sectionId: number;
    //难易程度
    degreeDifficulty: number;
    //试题类型
    questionType: number;
    gradeType: number;
    //搜索关键字
    keyword: string;
    externalType: number = 2;
    //试题内容
    questionContent: string;
    answerTips: string;
    answerKeyA: string;
    answerKeyB: string;
    answerKeyC: string;
    answerKeyD: string;
    answerKeyE: string;
    answerKeyF: string;
    answerKeyG: string;
    answerKeyH: string;
    answerKeyI: string;
    answerKeyJ: string;
    answerKeyK: string;
    answerKeyL: string;
    answerKeyM: string;
    answerKeyN: string;
    answerKeyO: string;
    //正确答案
    correctAnswer: string;
    listAnswer: any;
    isAudit: string;
    chapterName: string;
    sectionName: string;
    sisterId: string;
    categoryList: any = [];
}